import { useMutation, useQuery } from '@tanstack/react-query'
import { AXIOS_INSTANCE } from '../api'
import { queryClient } from '../store/provider/TanStackProvider'
import { ChargeItemResMock } from '../types/chargeItem.type'
import { GeneralResMock } from '../types/general.type'

type Props = {
  page?: number
  limit?: number
  item_type?: string
}
export const useChargeItems = ({ page, limit, item_type }: Props = {}) => {
  const { data, isLoading: chargeItemsIsLoading } = useQuery({
    queryFn: async () => {
      const { data } = await AXIOS_INSTANCE.get<GeneralResMock<ChargeItemResMock[]>>(`charge_items`, {
        params: {
          ...(page && { 'page[number]': page }),
          ...(limit && { 'page[size]': limit }),
          ...(item_type && { item_type })
        }
      })
      return data
    },
    queryKey: ['chargeItems']
  })

  const { mutateAsync: createChargeItem } = useMutation({
    mutationFn: async (formVal: any) => {
      const { data } = await AXIOS_INSTANCE.post('charge_items', formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chargeItems'] })
    }
  })

  const { mutateAsync: updateChargeItem } = useMutation({
    mutationFn: async ({ formVal, id }: { formVal: any; id: string }) => {
      const { data } = await AXIOS_INSTANCE.patch(`charge_items/${id}`, formVal, {
        headers: { 'Content-Type': 'application/vnd.api+json' }
      })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chargeItems'] })
    }
  })

  const { mutateAsync: deleteChargeItem } = useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await AXIOS_INSTANCE.delete(`charge_items/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chargeItems'] })
    }
  })

  return {
    createChargeItem,
    chargeItems: data?.data,
    includedData: data?.included,
    pagination: data?.meta?.pagination,
    chargeItemsIsLoading,
    updateChargeItem,
    deleteChargeItem
  }
}
